/**
 * Table of Contents JS 
 */

if (document.querySelector('.c-table-of-contents')) {

  const tocEl = document.querySelectorAll('.c-table-of-contents li > a');
  const observerOptions = {
    rootMargin: '0px 0px -50%',
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => {
      const tocEl = document.querySelector(`[href="#${e.target.id}"]`);
      if(e.isIntersecting) {
        tocEl.parentElement.classList.add('active');
      } else {
        tocEl.parentElement.classList.remove('active');
      }
    })
  }, observerOptions);

  tocEl.forEach(a => {
    const heading = document.getElementById(a.getAttribute('href').replace('#', ''));
    observer.observe(heading);
  });
}